import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TitleService } from '../../shared/title.service';
import { Character } from '../character';
import { Tribe } from '../tribe';
import { TribeService } from '../tribe.service';
import { UserService } from '../user.service';

@Component({
  selector: 'app-user-setup',
  templateUrl: './user-setup.component.html',
  styleUrls: ['./user-setup.component.scss'],
  standalone: false
})
export class UserSetupComponent implements OnInit {
  private tribeService = inject(TribeService);
  private userService = inject(UserService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private titleService = inject(TitleService);

  selectedTribe: string;
  selectedCharacter: string;
  name: string;
  tribes: Tribe[];
  isLoading = false;
  error = null;

  ngOnInit() {
    this.route.data.subscribe((data) => {
      if (data['userInfo'].character) {
        this.router.navigate(['404'], { skipLocationChange: true });
      }
    });
    this.titleService.setTitle('Setup');
    this.getTribes();
  }

  getTribes(): void {
    this.tribeService.getTribes().subscribe((tribes) => (this.tribes = tribes));
  }

  onTribeChange(): void {
    this.selectedCharacter = null;
  }

  onSubmit(): void {
    this.isLoading = true;
    this.userService.setupUser(this.selectedCharacter, this.name).subscribe({
      next: () => {
        this.isLoading = false;
        this.userService.updateCurrentUser();
        this.router.navigate(['']);
      },
      error: (err) => {
        this.isLoading = false;
        this.error = err?.error?.message;
      }
    });
  }

  get characterList(): Character[] {
    if (this.selectedTribe) {
      return this.tribes.find((e) => e.id === this.selectedTribe).characters;
    } else {
      return [];
    }
  }

  get isSubmitDisabled(): boolean {
    return !this.name || !this.name.trim() || !this.selectedCharacter;
  }
}
